import { useCheckoutStore } from "@/pages/checkout/stores/use-checkout-store";
import { useUserInfo } from "@/providers/user-info-provider";
import { RETURN_DEVICE_COUNTRIES } from "@/common/constants";
import { hasRequiredFields, isFormValid } from "@/pages/checkout/validation/checkout-validation";
import type { ValidationErrors } from "@/pages/checkout/validation/checkout-validation";

export const useCheckoutForm = () => {
  const form = useCheckoutStore((s) => s.form);
  const hasSubmitAttempted = useCheckoutStore((s) => s.hasSubmitAttempted);
  const markSubmitAttempted = useCheckoutStore((s) => s.markSubmitAttempted);
  const updateField = useCheckoutStore((s) => s.updateField);
  const amazonianInfo = useUserInfo();

  const homeCountry = amazonianInfo.basicInfo.addresses.home.country;
  const isDeviceReturnRequired = RETURN_DEVICE_COUNTRIES.includes(homeCountry);

  const isFilled = hasRequiredFields(form, isDeviceReturnRequired);

  const validationErrors: ValidationErrors = hasSubmitAttempted
    ? isFormValid(form, isDeviceReturnRequired).errors
    : {};

  return {
    form,
    validationErrors,
    updateField,
    markSubmitAttempted,
    isDeviceReturnRequired,
    isFilled,
  };
};
